import React from 'react';
import * as styles from './InfoText.module.scss';
import classNames from 'classnames';
import * as Icons from './icons';

export default function InfoText({
  tag: Tag = 'div',
  icon,
  className,
  children,
  ...rest
}) {
  const Icon = Icons[icon] ?? null;

  return !children ? null : (
    <Tag
      className={classNames(styles.wrapper, className)}
      {...rest}
    >
      {Icon && (
        <div className={classNames('info-text-icon', styles.icon)}>
          <Icon />
        </div>
      )}
      {children}
    </Tag>
  );
}
